/**
=========================================================
* MD UI Dashboard PRO React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/MD-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the MDware.
*/
import MDBox from 'components/MDBox'
import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

export default function DataTableData() {
  const AppService = useAppServices()
  const navigate = useNavigate()
  const [List, setList] = useState([])
  const [loader, setloader] = useState(true)

  const getAppCompanies = async () => {
    const { response } = await AppService.appcompanies.get()
    // console.log(response, 'getAppCompanies')
    if (response) {
      setList(response.data)
      setloader(false)
    } else {
      setList([])
      setloader(false)
    }
  }
  const onLoad = () => {
    getAppCompanies()
  }

  useEffect(onLoad, [])
  return {
    loader: loader,
    handleRefresh: onLoad,
    dataTableData: {
      columns: [
        { Header: 'Name', accessor: 'name' },
        { Header: 'LocationId', accessor: 'location_id' },
        { Header: 'CompanyId', accessor: 'company_id' },
        { Header: 'UserId', accessor: 'user_id' },
        { Header: 'Client Secret', accessor: 'client_secret' },
        { Header: 'address', accessor: 'address' },
        { Header: 'website', accessor: 'website' },
        { Header: 'Domain', accessor: 'domain' },
        { Header: 'Relationship Number', accessor: 'relationship_number' },
        { Header: 'Customer Type', accessor: 'customer_type' },
        { Header: 'yearly Price', accessor: 'yearly_price' },
        { Header: 'First Payment Date', accessor: 'first_payment_date' },
        { Header: 'currency', accessor: 'currency' },
      ],

      rows: List.map((data) => ({
        location_id: data.location_id,
        company_id: data.CompanyID,
        user_id: data.User_id,
        name: data.Name,
        client_secret: data.client_secret,
        address: data.address,
        website: data.website,
        domain: data.Domain,
        relationship_number: data.relationship_number,
        customer_type: data.customer_type,
        yearly_price: data.yearly_price,
        first_payment_date: data.first_payment_date,
        currency: data.currency,
      })),
    },
  }
}
